import type { DriveStep } from 'driver.js'

export const dashboardTour: Array<DriveStep> = [
  {
    element: '#dashboard-header',
    popover: {
      title: 'Welcome to ModelStack! 🚀',
      description:
        "This is your command center for managing AI API requests across 100+ models. Let's take a quick 2-minute tour.",
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '#analytics-overview',
    popover: {
      title: 'Usage Analytics',
      description:
        'Track your API usage, costs, and token consumption in real-time. This dashboard will populate once you make your first request.',
      side: 'bottom',
    },
  },
  {
    element: '#sidebar-nav-models',
    popover: {
      title: 'Browse Models',
      description:
        'Access 100+ AI models including Claude, GPT, Gemini, DeepSeek, Grok, Qwen, Kimi, and more—all through one unified API.',
      side: 'right',
    },
  },
  {
    element: '#sidebar-nav-billing',
    popover: {
      title: 'Manage Billing',
      description:
        'View your current plan, track spending, add credits, and upgrade for access to premium models.',
      side: 'right',
    },
  },
  {
    element: '#api-key-section',
    popover: {
      title: 'Create Your First API Key',
      description:
        'Generate an API key to start making requests. You can create multiple keys for different projects and track usage per key.',
      side: 'left',
      showButtons: ['next', 'close'],
    },
  },
  {
    popover: {
      title: 'Ready to Start? 🎯',
      description:
        'Click "Create API Key" below to generate your first key, then we\'ll show you how to integrate it into your code.',
      showButtons: ['close'],
    },
  },
]
